import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function ReportsEmptyIcon({ height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      fill="transparent"
      height={height ?? 40}
      viewBoxDimensions="0 0 40 40"
      width={width ?? 40}
    >
      <path
        d="M36 14.5h-9.25a3.25 3.25 0 0 1-3.25-3.25V2H6.75A1.75 1.75 0 0 0 5 3.75v32.5c0 1.508.449 1.957 1.627 1.76L6.75 38h27.5A1.75 1.75 0 0 0 36 36.25V14.5zm-.084-1.5a1.75 1.75 0 0 0-.428-.701l-9.786-9.787A1.75 1.75 0 0 0 25 2.084v9.166c0 .966.784 1.75 1.75 1.75h9.166zM3.5 36.25V3.75A3.25 3.25 0 0 1 6.75.5h17.715a3.25 3.25 0 0 1 2.297.951l9.787 9.787a3.25 3.25 0 0 1 .951 2.297V36.25a3.25 3.25 0 0 1-3.25 3.25H6.81c-2.116.325-3.31-.893-3.31-3.25zM9.771 8.667a.75.75 0 0 1 0-1.5h9.913a.75.75 0 1 1 0 1.5H9.771zm0 8.75a.75.75 0 0 1 0-1.5h11.941a.75.75 0 1 1 0 1.5H9.772zm0 7.916a.75.75 0 1 1 0-1.5h20.834a.75.75 0 0 1 0 1.5H9.77zm0 7.084a.75.75 0 0 1 0-1.5h20.834a.75.75 0 1 1 0 1.5H9.77z"
        fill="#9CA7AB"
        fillRule="nonzero"
      />
    </SimpleIcon>
  );
}
